import React, { useState, useEffect } from 'react';
import ChangeLog from './ChangeLogDropDown';
import LastRunReport from './LastRunReport';
import '../Shared/Dashboard.css'

const Dashboard = ({autoCompleteData, autoCompleteLoading, fetchAutoComplete, syncOverride, toggleOverride}) => {
    const [jobIsRunning, setJobIsRunning] = useState(false);

    useEffect(() => {
        if(!autoCompleteLoading && !autoCompleteData) {
            fetchAutoComplete()
        }
    }, []);

    const updateJobState = (isRunning) => {
        setJobIsRunning(isRunning)
    }
   
    return (
    <>
    <h1 className="page-title">Sync Job Log</h1>
    <div>
        <LastRunReport updateJobState={updateJobState}/>
        <ChangeLog isRunning={jobIsRunning}/>
        <div className='override-sync-button-container'>
            {
                syncOverride === true
                ? <button className='k-button-solid-primary k-button-lg sync-button' onClick={() => toggleOverride()}>Re-Enable Sync Job</button>
                : <button className='k-button-solid-secondary k-button-lg sync-button' onClick={() => toggleOverride()}>Disable Sync Job</button>
            }
        </div>
    </div>
    </>
    )
};

export default Dashboard;